import Client from './KomodoClient';

// Typed projection of the merchant/company settings (formats, feature flags, BusinessFormat).
const settings = () => Client.get('/api/data/acc-settings');

// Merchant-level rows (DeptCode = '') plus the given company's overrides.
const listByDept = (deptCode) =>
	Client.get(`/api/acc-info/company/${encodeURIComponent(deptCode || '')}`);

// Batch upsert; komodo refreshes its cached AccSetting afterwards.
const saveList = (rows) => Client.post('/api/acc-info/save-list', rows);

export default { settings, listByDept, saveList };
